import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.knowledge.document_results');
import { OnInit, OnDestroy } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-knowledge-document_results',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.knowledge.document_results/view.scss */
:host {
  display: block;
  height: 100%;
  --corpus-background: #f7f9fc;
  --corpus-surface: #ffffff;
  --corpus-text: #0f172a;
  --corpus-muted: #64748b;
  --corpus-border: #dbe4ef;
  --corpus-highlight: #eff6ff;
  --corpus-primary: #1764b4;
}

:host-context([data-theme=dark]) {
  --corpus-background: #101a2b;
  --corpus-surface: #172337;
  --corpus-text: #e5edf8;
  --corpus-muted: #a8b8ce;
  --corpus-border: #31435d;
  --corpus-highlight: #203957;
  --corpus-primary: #91c4ff;
}

.corpus-page {
  height: 100%;
  overflow: auto;
  background: var(--corpus-background);
  color: var(--corpus-text);
  font-size: 13px;
  line-height: 1.65;
}
.corpus-page h1, .corpus-page h2, .corpus-page h3, .corpus-page p {
  margin: 0;
}
.corpus-page h1 {
  font-size: 18px;
  font-weight: 700;
}
.corpus-page h2 {
  font-size: 15px;
  font-weight: 700;
  overflow-wrap: anywhere;
}
.corpus-page h3 {
  font-size: 13px;
  font-weight: 700;
}
.corpus-page button, .corpus-page a, .corpus-page input, .corpus-page select {
  font: inherit;
}
.corpus-page button, .corpus-page a {
  -webkit-tap-highlight-color: transparent;
}
.corpus-page button:focus-visible, .corpus-page a:focus-visible, .corpus-page input:focus-visible, .corpus-page select:focus-visible, .corpus-page summary:focus-visible {
  outline: 2px solid var(--corpus-primary);
  outline-offset: 3px;
}

.corpus-header {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 24px 28px;
  border-bottom: 1px solid var(--corpus-border);
  background: var(--corpus-surface);
}
.corpus-header p:not(.corpus-eyebrow) {
  margin-top: 6px;
  color: var(--corpus-muted);
}

.corpus-eyebrow {
  color: var(--corpus-primary);
  font-size: 12px;
  font-weight: 700;
}

.corpus-actions {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
}

.corpus-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 7px;
  min-height: 36px;
  padding: 6px 12px;
  border: 1px solid var(--corpus-border);
  border-radius: 7px;
  background: var(--corpus-surface);
  color: var(--corpus-primary);
  text-decoration: none;
  cursor: pointer;
  white-space: nowrap;
}
.corpus-button:hover:not(:disabled) {
  background: var(--corpus-highlight);
}
.corpus-button:disabled {
  opacity: 0.55;
  cursor: default;
}
.corpus-button.is-primary {
  background: #1764b4;
  border-color: #1764b4;
  color: #fff;
}

.corpus-content {
  display: flex;
  flex-direction: column;
  gap: 24px;
  max-width: 1720px;
  margin: 0 auto;
  padding: 24px 28px 40px;
  min-width: 0;
}

.corpus-panel, .corpus-status {
  padding: 20px;
  border: 1px solid var(--corpus-border);
  border-radius: 12px;
  background: var(--corpus-surface);
  min-width: 0;
}

.corpus-section-heading, .corpus-status-heading, .corpus-result-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}
.corpus-section-heading > span:not(.corpus-badge), .corpus-status-heading > span:not(.corpus-badge), .corpus-result-title > span:not(.corpus-badge) {
  flex-shrink: 0;
  color: var(--corpus-muted);
  font-size: 12px;
}

.corpus-section-heading {
  margin-bottom: 14px;
}

.corpus-status-heading {
  align-items: flex-start;
}
.corpus-status-heading p {
  margin-top: 4px;
  color: var(--corpus-muted);
}

.corpus-stats {
  display: grid;
  grid-template-columns: repeat(6, minmax(0, 1fr));
  gap: 16px;
  margin: 18px 0;
}
.corpus-stats > div {
  display: flex;
  flex-direction: column;
  border-right: 1px solid var(--corpus-border);
  padding-left: 12px;
}
.corpus-stats > div:first-child {
  padding-left: 0;
}
.corpus-stats > div:last-child {
  border: 0;
}
.corpus-stats strong {
  font-size: 25px;
  line-height: 1.4;
}
.corpus-stats span {
  font-size: 12px;
  color: var(--corpus-muted);
}

.corpus-progress {
  height: 6px;
  overflow: hidden;
  border-radius: 3px;
  background: var(--corpus-border);
  margin-bottom: 7px;
}
.corpus-progress span {
  display: block;
  height: 100%;
  background: #3184ca;
  transition: width 0.2s;
}

.corpus-muted {
  display: block;
  color: var(--corpus-muted);
  font-size: 12px;
  overflow-wrap: anywhere;
}

.corpus-dataset-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 14px;
  margin-bottom: 9px;
}

.corpus-dataset {
  display: flex;
  align-items: center;
  gap: 14px;
  border: 1px solid var(--corpus-border);
  border-radius: 10px;
  background: var(--corpus-surface);
  padding: 18px;
}
.corpus-dataset p, .corpus-dataset small {
  color: var(--corpus-muted);
}
.corpus-dataset h3 {
  overflow-wrap: anywhere;
}

.corpus-dataset-icon {
  display: grid;
  place-items: center;
  width: 42px;
  height: 42px;
  flex-shrink: 0;
  border-radius: 10px;
  background: var(--corpus-highlight);
  color: var(--corpus-primary);
  font-size: 21px;
}

.corpus-badge {
  display: inline-flex;
  align-items: center;
  border-radius: 5px;
  padding: 2px 7px;
  background: var(--corpus-background);
  color: var(--corpus-muted);
  border: 1px solid var(--corpus-border);
  font-size: 11px;
  white-space: nowrap;
}
.corpus-badge.is-complete {
  background: #ecfdf3;
  color: #166534;
  border-color: #b9e5c7;
}
.corpus-badge.is-error {
  background: #fff1f2;
  color: #9f1239;
  border-color: #fecdd3;
}
.corpus-badge.is-running {
  background: #eff6ff;
  color: #1d4ed8;
  border-color: #bfdbfe;
}

.corpus-metrics-note {
  padding: 10px 12px;
  border-radius: 7px;
  background: var(--corpus-highlight);
  color: var(--corpus-primary);
  white-space: pre-wrap;
  margin-bottom: 18px !important;
}

.corpus-summary-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 16px;
}

.corpus-summary-stage {
  min-width: 0;
}
.corpus-summary-stage > .corpus-muted {
  margin: 4px 0 12px;
}

.corpus-summary-entry {
  padding: 12px;
  margin-top: 8px;
  border: 1px solid var(--corpus-border);
  border-radius: 8px;
}
.corpus-summary-entry .corpus-result-title {
  align-items: flex-start;
}
.corpus-summary-entry .corpus-result-title strong {
  overflow-wrap: anywhere;
}

.corpus-metrics {
  margin: 10px 0 0;
  font-size: 12px;
}
.corpus-metrics > div {
  display: flex;
  justify-content: space-between;
  gap: 12px;
  padding: 3px 0;
}
.corpus-metrics dt {
  color: var(--corpus-muted);
  flex-shrink: 0;
  max-width: 55%;
  overflow-wrap: anywhere;
}
.corpus-metrics dd {
  margin: 0;
  text-align: right;
  overflow-wrap: anywhere;
}

.corpus-selection, .corpus-output {
  margin-top: 14px;
  padding: 10px 12px;
  border: 1px solid var(--corpus-border);
  border-radius: 7px;
}
.corpus-selection summary, .corpus-output summary {
  cursor: pointer;
  font-weight: 600;
}
.corpus-selection pre, .corpus-output pre {
  margin: 10px 0 0;
  font-size: 12px;
  line-height: 1.75;
  white-space: pre-wrap;
  overflow-wrap: anywhere;
  max-height: 360px;
  overflow: auto;
  font-family: ui-monospace, monospace;
}

.corpus-filters {
  display: flex;
  align-items: flex-end;
  gap: 12px;
  margin-bottom: 16px;
}
.corpus-filters label {
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.corpus-filters label > span {
  color: var(--corpus-muted);
  font-size: 12px;
}
.corpus-filters input, .corpus-filters select {
  min-height: 36px;
  border: 1px solid var(--corpus-border);
  border-radius: 7px;
  background: var(--corpus-surface);
  color: var(--corpus-text);
  padding: 6px 10px;
}
.corpus-filters select {
  min-width: 180px;
}

.corpus-search {
  flex: 1;
  min-width: 120px;
}

.corpus-table-scroll {
  overflow-x: auto;
}

.corpus-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 12px;
}
.corpus-table th, .corpus-table td {
  padding: 12px 10px;
  border-bottom: 1px solid var(--corpus-border);
  text-align: left;
  vertical-align: middle;
}
.corpus-table th {
  color: var(--corpus-muted);
  font-weight: 600;
  background: var(--corpus-background);
  white-space: nowrap;
}
.corpus-table td {
  min-width: 65px;
}
.corpus-table .corpus-filename {
  min-width: 220px;
  max-width: 360px;
  overflow-wrap: anywhere;
  font-weight: 600;
}
.corpus-table tr.is-selected td {
  background: var(--corpus-highlight);
}
.corpus-table .corpus-badge, .corpus-table .corpus-link {
  white-space: nowrap;
}

.corpus-link {
  border: 0;
  background: transparent;
  color: var(--corpus-primary);
  font-weight: 600 !important;
  cursor: pointer;
  text-decoration: underline;
  text-underline-offset: 3px;
}

.corpus-pagination {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 14px;
}
.corpus-pagination > span {
  color: var(--corpus-muted);
  font-size: 12px;
}

.corpus-alert {
  padding: 11px 13px;
  border: 1px solid #fed7aa;
  border-radius: 7px;
  color: #9a3412;
  background: #fff7ed;
  overflow-wrap: anywhere;
}

.corpus-empty {
  padding: 24px;
  text-align: center;
  color: var(--corpus-muted);
  border: 1px dashed var(--corpus-border);
  border-radius: 8px;
}

.corpus-stage-tabs {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin: 22px 0 10px;
}
.corpus-stage-tabs button {
  padding: 8px 16px;
  border: 1px solid var(--corpus-border);
  border-radius: 7px;
  background: var(--corpus-surface);
  color: var(--corpus-muted);
  cursor: pointer;
}
.corpus-stage-tabs button.is-active {
  background: var(--corpus-highlight);
  color: var(--corpus-primary);
  border-color: var(--corpus-primary);
  font-weight: 700;
}

.corpus-result-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 16px;
  margin-top: 14px;
}

.corpus-result {
  border: 1px solid var(--corpus-border);
  padding: 16px;
  border-radius: 9px;
  min-width: 0;
}
.corpus-result > .corpus-muted {
  margin-top: 6px;
}
.corpus-result > .corpus-button {
  margin-top: 12px;
}
.corpus-result > .corpus-alert {
  margin-top: 10px;
}
.corpus-result h3 {
  overflow-wrap: anywhere;
}

.corpus-chunk {
  border-top: 1px solid var(--corpus-border);
  padding: 10px 0;
}
.corpus-chunk strong {
  font-size: 12px;
  color: var(--corpus-primary);
}

@media (max-width: 1100px) {
  .corpus-stats {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
  .corpus-summary-grid {
    grid-template-columns: 1fr;
  }
  .corpus-summary-stage {
    padding-bottom: 14px;
    border-bottom: 1px solid var(--corpus-border);
  }
  .corpus-summary-stage:last-child {
    padding-bottom: 0;
    border-bottom: 0;
  }
}
@media (max-width: 700px) {
  .corpus-content {
    padding: 16px 12px 28px;
  }
  .corpus-header {
    padding: 18px 16px;
  }
  .corpus-panel, .corpus-status {
    padding: 15px;
  }
  .corpus-dataset-grid, .corpus-result-grid {
    grid-template-columns: 1fr;
  }
  .corpus-stats {
    grid-template-columns: repeat(2, 1fr);
  }
  .corpus-stats > div {
    padding-left: 0;
    border: 0;
  }
  .corpus-filters {
    flex-wrap: wrap;
  }
  .corpus-filters label:first-child {
    width: 100%;
  }
  .corpus-section-heading {
    flex-wrap: wrap;
  }
}
.corpus-benchmark-stage {
  padding: 20px 0;
  border-top: 1px solid var(--corpus-border);
}
.corpus-benchmark-stage:first-of-type {
  border-top: 0;
  padding-top: 0;
}

.corpus-stage-heading {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
}
.corpus-stage-heading h3 {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
}
.corpus-stage-heading p {
  margin-top: 6px;
}

.corpus-stage-number {
  display: inline-grid;
  place-items: center;
  width: 25px;
  height: 25px;
  border-radius: 50%;
  color: var(--corpus-primary);
  background: var(--corpus-highlight);
  font-size: 12px;
}

.corpus-stage-context {
  display: flex;
  flex-wrap: wrap;
  gap: 8px 20px;
  margin: 12px 0;
  font-size: 12px;
  color: var(--corpus-muted);
}
.corpus-stage-context strong {
  color: var(--corpus-primary);
}

.corpus-comparison-table {
  min-width: 900px;
}
.corpus-comparison-table th[scope=row] {
  background: transparent;
  color: var(--corpus-text);
  white-space: normal;
  width: 22%;
}
.corpus-comparison-table td {
  width: 15%;
}
.corpus-comparison-table td:nth-child(2) {
  min-width: 175px;
}
.corpus-comparison-table td small {
  margin-top: 3px;
}
.corpus-comparison-table tr.is-selected th {
  background: var(--corpus-highlight);
}

.corpus-stage-selection {
  margin-top: 10px !important;
  font-weight: 600;
  font-size: 12px;
  color: var(--corpus-primary);
}

.corpus-global-selection {
  padding: 18px;
  border: 1px solid var(--corpus-primary);
  border-radius: 9px;
  background: var(--corpus-highlight);
}
.corpus-global-selection > p:not(.corpus-muted) {
  font-weight: 700;
}
.corpus-global-selection > .corpus-muted {
  margin-top: 6px;
}

.corpus-aggregate-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 18px;
  margin-top: 14px;
}
.corpus-aggregate-grid article {
  min-width: 0;
}
.corpus-aggregate-grid article > p {
  margin-top: 12px;
}

.corpus-evidence > summary {
  cursor: pointer;
  font-size: 14px;
  font-weight: 700;
  padding: 15px 18px;
  border: 1px solid var(--corpus-border);
  border-radius: 9px;
  background: var(--corpus-surface);
}
.corpus-evidence > .corpus-panel {
  margin-top: 18px;
}
.corpus-evidence > .corpus-evidence-note {
  margin-top: 12px;
}

.corpus-evidence-note {
  color: var(--corpus-muted);
  font-size: 12px;
  margin-bottom: 14px !important;
}

@media (max-width: 700px) {
  .corpus-stage-heading {
    flex-wrap: wrap;
  }
  .corpus-global-selection {
    padding: 14px;
  }
}
.corpus-comparison-note {
  color: var(--corpus-muted);
  font-size: 12px;
  margin-bottom: 18px !important;
}

.corpus-representative {
  margin-top: 20px;
  padding: 16px;
  border: 1px solid var(--corpus-border);
  border-radius: 8px;
  min-width: 0;
}
.corpus-representative h4 {
  margin: 0;
  font-size: 13px;
  font-weight: 700;
}
.corpus-representative > p {
  margin-bottom: 8px;
}
.corpus-representative .corpus-section-heading {
  margin-bottom: 8px;
}

.corpus-representative-table th[scope=row] {
  background: transparent;
  color: var(--corpus-text);
}
.corpus-representative-table td {
  white-space: nowrap;
}
.corpus-representative-table th strong {
  display: block;
}`],
})
export class PageKnowledgeDocument_resultsComponent implements OnInit, OnDestroy {
    public overview: any = null;
    public detail: any = null;
    public loading = false;
    public detailLoading = false;
    public error = '';
    public detailError = '';
    public query = '';
    public dataset = '';
    public offset = 0;
    public readonly limit = 40;
    public selectedDocument: any = null;
    public activeStage = 'parsing';
    public readonly candidates: any = {
        parsing: ['docling', 'mineru', 'marker'],
        chunking: ['semantic', 'recursive', 'markdown', 'hybrid'],
        embedding: ['bge-m3', 'qwen3-embedding']
    };
    public readonly stages = [
        { id: 'parsing', label: '문서 파싱', description: 'Docling + Granite-Docling (기본/OCR 페이지 복구 포함) / MinerU / Marker + Qwen3-VL-8B' },
        { id: 'chunking', label: '청킹', description: 'Semantic / Recursive / Markdown / Hybrid' },
        { id: 'embedding', label: '임베딩', description: 'BGE-M3 / Qwen3-embedding-8B' }
    ];
    private destroyed = false;
    private pollTimer: any = null;
    private detailSequence = 0;

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        await this.load();
    }

    public ngOnDestroy() {
        this.destroyed = true;
        this.detailSequence += 1;
        if (this.pollTimer) clearTimeout(this.pollTimer);
    }

    private async call(name: string, params: any = {}) {
        const response = await wiz.call(name, params);
        if (response?.code !== 200) throw new Error(response?.message || response?.data?.message || '결과를 불러오지 못했습니다.');
        return response.data;
    }

    public async load(reset = false) {
        if (this.loading) return;
        if (reset) this.offset = 0;
        if (this.pollTimer) clearTimeout(this.pollTimer);
        this.loading = true;
        this.error = '';
        await this.service.render();
        try {
            const data = await this.call('overview', { limit: this.limit, offset: this.offset, query: this.query.trim(), dataset: this.dataset });
            if (this.destroyed) return;
            this.overview = data;
            if (this.selectedDocument) {
                const current = (data.documents || []).find((item: any) => item.id === this.selectedDocument.id);
                if (current) {
                    this.selectedDocument = current;
                    await this.selectDocument(current);
                } else {
                    this.selectedDocument = null;
                    this.detail = null;
                    this.detailSequence += 1;
                }
            }
        } catch (error: any) {
            this.error = error?.message || '결과를 불러오지 못했습니다.';
        } finally {
            this.loading = false;
            if (!this.destroyed) {
                await this.service.render();
                if (this.overview?.status?.running || ['running', 'queued', 'waiting-services'].includes(this.overview?.status?.state)) {
                    this.pollTimer = setTimeout(() => this.load(), 15000);
                }
            }
        }
    }

    public async changePage(direction: number) {
        this.offset = Math.max(0, this.offset + direction * this.limit);
        await this.load();
    }

    public filteredTotal() {
        return Number(this.overview?.filteredTotal ?? this.overview?.totalDocuments ?? 0);
    }

    public hasNext() {
        if (this.overview?.nextOffset !== undefined) return this.overview.nextOffset !== null;
        return this.offset + (this.overview?.documents?.length || 0) < this.filteredTotal();
    }

    public pageEnd() {
        return this.offset + (this.overview?.documents?.length || 0);
    }

    public async selectDocument(document: any) {
        const sequence = ++this.detailSequence;
        this.selectedDocument = document;
        this.detail = null;
        this.detailError = '';
        this.detailLoading = true;
        await this.service.render();
        try {
            const data = await this.call('detail', { document_id: document.id });
            if (this.destroyed || sequence !== this.detailSequence) return;
            this.detail = data;
        } catch (error: any) {
            if (sequence === this.detailSequence) this.detailError = error?.message || '문서 상세 결과를 불러오지 못했습니다.';
        } finally {
            if (!this.destroyed && sequence === this.detailSequence) {
                this.detailLoading = false;
                await this.service.render();
            }
        }
    }

    public async selectStage(stage: string) {
        this.activeStage = stage;
        await this.service.render();
    }

    public rows(stage: string) {
        const value = this.detail?.[stage];
        return Array.isArray(value) ? value : [];
    }

    public corpusTotal() {
        return Number(this.overview?.benchmark?.totalDocuments ?? this.overview?.totalDocuments ?? 823);
    }

    public activeParserCount() {
        return (this.overview?.benchmark?.comparisonPolicy?.parserIds || this.candidates.parsing).length;
    }

    public pausedParserText() {
        return (this.overview?.benchmark?.comparisonPolicy?.pausedParserIds || [])
            .map((id: string) => this.label({ id })).join(' / ');
    }

    public benchmarkStage(stage: string) {
        return this.overview?.benchmark?.stages?.[stage] || {};
    }

    public benchmarkRows(stage: string) {
        const rows = this.benchmarkStage(stage).candidates;
        if (Array.isArray(rows) && rows.length) return rows;
        return (this.candidates[stage] || []).map((id: string) => ({
            id, totalDocuments: this.corpusTotal(), completedDocuments: 0,
            failedDocuments: 0, partialDocuments: 0, pendingDocuments: this.corpusTotal(),
            commonMetrics: { qualityProxyScore: null }
        }));
    }

    public representativeEvaluation() {
        return this.overview?.benchmark?.representativeEvaluation || {};
    }

    public representativeStage(stage: string) {
        return this.representativeEvaluation()?.stages?.[stage] || {};
    }

    public representativeDefinitions(stage: string) {
        const definitions = this.representativeStage(stage).definitions;
        return Array.isArray(definitions) ? definitions : [];
    }

    public representativeRows(stage: string) {
        const rows = this.representativeStage(stage).candidates;
        return Array.isArray(rows) ? rows : [];
    }

    public representativeStatus(stage: string) {
        return this.representativeStage(stage).status || this.representativeEvaluation().status || 'pending';
    }

    public representativeReference(stage: string) {
        const value = this.representativeStage(stage).referenceKind;
        const labels: any = {
            'pdf-native-text': 'PDF 내장 텍스트 자동 참조',
            'pdf-text-layer-relative-two-page-windows': '원본 PDF 텍스트 레이어 대비 상대 오류율 · 동일 2페이지 구간',
            'selected-parser-text': '전체 적용 파서 원문 자동 참조',
            'verified-selected-parser-source-offsets': '선정 파서 원문의 청크 위치 일치 검증',
            'synthetic-anchor-retrieval': '문서에서 생성한 자동 검색 평가셋',
            'automatic-source-filename': '공통 완료 문서의 파일 제목으로 만든 자동 검색 질의'
        };
        return labels[value] || value || '평가 기준 대기';
    }

    public representativeValue(item: any, definition: any) {
        const value = item?.metrics?.[definition.key];
        if (typeof value !== 'number' || !Number.isFinite(value)) {
            return item?.status === 'paused' ? '중지 · 측정 제외' : item?.measuredDocuments ? '측정 불가' : '측정 대기';
        }
        if (definition.unit === 'percent') {
            return (value * 100).toLocaleString('ko-KR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + '%';
        }
        const suffixes: any = { chars: '자', pagesPerSecond: '페이지/초', vectorsPerSecond: '벡터/초' };
        return value.toLocaleString('ko-KR', { maximumFractionDigits: 4 }) + (suffixes[definition.unit] || '');
    }

    public representativeCohort(stage: string) {
        const count = this.representativeStage(stage).evaluatedDocuments || 0;
        return stage === 'embedding' ? '공통 완료 코호트 ' + count + '개' : '처리 결과 측정 ' + count + '개';
    }

    public representativeCounts(item: any, stage: string) {
        const counts = { ...(this.representativeStage(stage).counts || {}), ...(item?.counts || {}) };
        const number = (value: any) => typeof value === 'number' && Number.isFinite(value) ? value.toLocaleString('ko-KR') : '대기';
        if (item?.status === 'paused') return '';
        if (stage === 'parsing') {
            return 'CER/WER 참조 ' + number(counts.referenceDocuments) + '개 문서 · '
                + number(counts.referencePages) + '페이지 / 참조 없음 '
                + number(counts.noReferenceDocuments) + '개 문서 · ' + number(counts.noReferencePages) + '페이지';
        }
        if (stage === 'embedding') {
            return '자동 질의 ' + number(counts.queryCount) + '개 / 공통 코호트 '
                + number(counts.cohortN ?? counts.pairedDocuments ?? item?.measuredDocuments) + '개 문서 · 제목 질의 제외 '
                + number(counts.excludedFilenameDocuments) + '개';
        }
        return '';
    }

    public representativeDirection(definition: any) {
        return definition.direction === 'lower' ? '낮을수록 좋음' : definition.direction === 'higher' ? '높을수록 좋음' : '참고 지표';
    }

    public stageInput(stage: string) {
        const context = this.benchmarkStage(stage).context || {};
        if (stage === 'parsing') return '전체 ' + this.corpusTotal() + '개 원본 문서';
        if (!context.parserId) return '전체 문서 기준 파싱 모델 선정 대기';
        const parser = this.label({ id: context.parserId });
        if (stage === 'chunking') return parser + '의 전체 문서 파싱 결과';
        if (!context.chunkerId) return '전체 문서 기준 청킹 방식 선정 대기';
        return parser + ' → ' + this.label({ id: context.chunkerId }) + '의 전체 청크';
    }

    public stageSelection(stage: string) {
        const selection = this.benchmarkStage(stage).selection;
        return selection?.id ? this.label(selection) : '전량 비교 후 선정';
    }

    public candidateSelected(stage: string, item: any) {
        return this.benchmarkStage(stage).selection?.id === item.id;
    }

    public quantity(item: any, stage: string) {
        const totals = item?.metrics?.totals || {};
        const key = stage === 'parsing' ? 'textChars' : stage === 'chunking' ? 'chunkCount' : 'vectorCount';
        if (typeof totals[key] !== 'number' || !Number.isFinite(totals[key])) return '—';
        return this.valueText(totals[key]) + (stage === 'parsing' ? '자' : stage === 'chunking' ? '청크' : '벡터');
    }

    public duration(value: any) {
        if (value === null || value === undefined) return '—';
        const seconds = Math.max(0, Number(value)) / 1000;
        if (!Number.isFinite(seconds)) return '—';
        if (seconds < 60) return seconds.toFixed(1) + '초';
        if (seconds < 3600) return Math.floor(seconds / 60) + '분 ' + Math.floor(seconds % 60) + '초';
        return Math.floor(seconds / 3600) + '시간 ' + Math.floor((seconds % 3600) / 60) + '분';
    }

    public qualityScore(item: any) {
        const value = item?.commonMetrics?.qualityProxyScore;
        return typeof value === 'number' && Number.isFinite(value) ? value.toFixed(4) : '—';
    }

    public corpusScore(item: any) {
        if (item?.paused) return '비교 제외';
        const value = item?.corpusQualityProxyScore;
        return typeof value === 'number' && Number.isFinite(value) ? value.toFixed(4) : '미확정';
    }

    public throughput(item: any, stage: string) {
        const metrics = item?.metrics || {};
        const key = stage === 'parsing' ? 'pagesPerSecond' : stage === 'chunking' ? 'chunksPerSecond' : 'vectorsPerSecond';
        const value = metrics[key];
        return typeof value === 'number' && Number.isFinite(value) ? this.valueText(value) + (stage === 'parsing' ? '페이지/초' : stage === 'chunking' ? '청크/초' : '벡터/초') : '—';
    }

    public globalSelection() {
        const selection = this.overview?.benchmark?.finalSelection;
        if (!selection) return '전체 ' + this.corpusTotal() + '개 문서의 단계별 비교가 끝나면 한 조합을 확정합니다.';
        return [selection.parserId, selection.chunkerId, selection.embeddingId]
            .map(id => this.label({ id })).join(' → ');
    }

    public downloadBenchmark() {
        if (!this.overview?.benchmark) return;
        this.service.file.download(this.overview.benchmark, 'corpus-comparison-823-documents.json');
    }

    public stageDescription() {
        return this.stages.find(stage => stage.id === this.activeStage)?.description || '';
    }

    public label(item: any) {
        const id = String(item?.label || item?.name || item?.model || item?.id || '');
        const labels: any = {
            docling: 'Docling + Granite-Docling', docling_granite: 'Docling + Granite-Docling',
            'docling-granite': 'Docling + Granite-Docling', mineru: 'MinerU',
            marker: 'Marker + Qwen3-VL-8B', marker_qwen: 'Marker + Qwen3-VL-8B',
            semantic: 'Semantic', recursive: 'Recursive', markdown: 'Markdown', hybrid: 'Hybrid',
            'baai/bge-m3': 'BGE-M3', 'qwen/qwen3-embedding-8b': 'Qwen3-embedding-8B',
            'bge-m3': 'BGE-M3', bge_m3: 'BGE-M3', 'qwen3-embedding': 'Qwen3-embedding-8B', 'qwen3-embedding-8b': 'Qwen3-embedding-8B'
        };
        return labels[id.toLowerCase()] || id || '이름 없음';
    }

    public statusLabel(value: any) {
        const labels: any = {
            pending: '실행 대기', queued: '실행 대기', 'waiting-services': '원격 서비스 복구 대기', ready: '준비됨', running: '처리 중',
            completed: '완료', complete: '완료', success: '완료', succeeded: '완료', indexed: '색인 완료',
            failed: '실패', error: '오류', blocked: '차단', skipped: '건너뜀', paused: '일시 중지',
            partial: '일부 완료', interrupted: '재개 필요', stale: '재처리 필요', missing: '파일 없음', available: '사용 가능',
            matched: '분류표 일치', unmatched: 'LLM 분류 대상', classified: 'AI 분류 완료', selected: '선정 완료', published: '운영 반영 완료'
        };
        return labels[String(value || 'pending')] || String(value);
    }

    public statusClass(value: any) {
        const state = String(value || 'pending');
        if (['completed', 'complete', 'success', 'succeeded', 'indexed', 'matched', 'classified', 'selected', 'published'].includes(state)) return 'is-complete';
        if (['failed', 'error', 'blocked', 'missing', 'interrupted', 'stale'].includes(state)) return 'is-error';
        if (['running', 'queued', 'partial', 'waiting-services'].includes(state)) return 'is-running';
        return '';
    }

    public progress() {
        const status = this.overview?.status || {};
        const total = Number(status.total || this.overview?.totalDocuments || 0);
        return total ? Math.min(100, Math.max(0, Number(status.completed || 0) / total * 100)) : 0;
    }

    public bytes(value: any) {
        const size = Number(value || 0);
        if (size < 1024) return size + ' B';
        const unit = size >= 1073741824 ? 1073741824 : size >= 1048576 ? 1048576 : 1024;
        return (size / unit).toFixed(1) + (unit === 1073741824 ? ' GB' : unit === 1048576 ? ' MB' : ' KB');
    }

    public categoryText(value: any) {
        if (Array.isArray(value)) return value.map(item => typeof item === 'object' ? ([item?.axis ? '축 ' + item.axis : '', item?.code, item?.name || item?.label].filter(Boolean).join(' · ') || JSON.stringify(item)) : item).join(' / ') || '미분류';
        if (value && typeof value === 'object') return Object.values(value).filter(Boolean).join(' / ') || '미분류';
        return value || '미분류';
    }

    public metricRows(metrics: any) {
        if (!metrics || typeof metrics !== 'object') return [];
        const labels: any = {
            elapsedMs: '처리 시간 (ms)', elapsed_ms: '처리 시간 (ms)', durationSeconds: '처리 시간 (초)',
            duration_seconds: '처리 시간 (초)', seconds: '처리 시간 (초)', elapsedSeconds: '처리 시간 (초)',
            pages: '페이지', pageCount: '페이지', characters: '문자 수', charCount: '문자 수',
            chunkCount: '청크 수', chunk_count: '청크 수', count: '건수', score: '평가 점수',
            qualityScore: '품질 점수', quality_score: '품질 점수', dimension: '벡터 차원',
            textChars: '문자 수', tokenCount: '토큰 수', processedPages: '처리 페이지',
            granitePages: 'Granite 완료 페이지', fallbackAttemptedPages: '기본/OCR 복구 시도 페이지',
            recoveredPages: '복구 완료 페이지', standardRecoveredPages: '기본 파이프라인 복구 페이지',
            ocrRecoveredPages: 'OCR 복구 페이지', verifiedBlankPages: '원본 공백 확인 페이지',
            lengthRecoveryPages: '정상 출력 잘림 복구', repetitionRecoveryPages: '반복 출력 복구',
            emptyOutputRecoveryPages: '빈 출력 복구',
            tableCount: '표 수', formulaCount: '수식 수', vectorCount: '벡터 수', inputCount: '입력 수',
            qualityProxyScore: '자동 품질 진단 점수', qualityDocumentCount: '품질 측정 문서',
            coverage: '커버리지', coverageRatio: '커버리지 비율', coverage_ratio: '커버리지 비율',
            throughput: '처리량', avgTokens: '평균 토큰 수', avgChars: '평균 문자 수',
            successRate: '성공률', total: '전체', completed: '완료', failed: '실패', pending: '대기',
            parserId: '파서', chunkerId: '청킹', embeddingId: '임베딩', selected: '선정',
            metric: '평가 지표', reason: '근거', state: '상태', status: '상태',
            collection: '컬렉션', model: '모델', retrieved: '검색 수', mrr: 'MRR', recall: 'Recall'
        };
        return Object.entries(metrics)
            .filter(([_, value]) => value !== undefined && value !== null)
            .map(([key, value]) => ({ key: labels[key] || key, value: this.valueText(value) }));
    }

    public valueText(value: any): string {
        if (typeof value === 'number') return Number.isInteger(value) ? value.toLocaleString('ko-KR') : Number(value.toFixed(4)).toLocaleString('ko-KR');
        if (typeof value === 'boolean') return value ? '예' : '아니요';
        if (typeof value === 'object') return JSON.stringify(value);
        return String(value);
    }

    public entryMetrics(item: any) {
        return this.metricRows(item?.metrics || item?.aggregateMetrics || {});
    }

    public chunkText(chunk: any) {
        return typeof chunk === 'string' ? chunk : String(chunk?.text || chunk?.content || chunk?.page_content || '');
    }

    public errors(value: any) {
        if (!value) return [];
        return Array.isArray(value) ? value.map(item => typeof item === 'string' ? item : (item?.message || item?.error || JSON.stringify(item))) : [typeof value === 'string' ? value : JSON.stringify(value)];
    }

    public json(value: any) {
        return JSON.stringify(value, null, 2);
    }

    public artifactUrl(stage: string, index: number) {
        const params = new URLSearchParams({ document_id: String(this.selectedDocument?.id || ''), stage, index: String(index) });
        return '/wiz/api/page.knowledge.document_results/artifact?' + params.toString();
    }

    public download() {
        if (!this.detail || !this.selectedDocument) return;
        this.service.file.download(this.detail, 'document-result-' + this.selectedDocument.id + '.json');
    }
}

export default PageKnowledgeDocument_resultsComponent;